import React, { useEffect, useState } from 'react';
import { Lightbulb, Compass } from 'lucide-react';
import { affFetch } from '../../lib/affApi';

export const DailyIdea = ({ isEs }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    affFetch(`/me/daily-idea?lang=${isEs ? 'es' : 'en'}`).then((r) => r.ok && r.json().then(setData)).catch(() => {});
  }, [isEs]);
  if (!data) return null;
  return (
    <div className="mt-6 grid lg:grid-cols-[1.2fr,1fr] gap-4" data-testid="aff-daily-idea">
      <div className="rounded-2xl border border-[#F77F11]/25 bg-gradient-to-br from-[#F77F11]/[0.07] to-white p-5">
        <p className="flex items-center gap-2 text-[11px] uppercase tracking-wider text-[#F77F11] font-bold">
          <Lightbulb className="w-4 h-4" /> {isEs ? 'Idea de venta de hoy' : "Today's sales idea"}
        </p>
        <p className="mt-2.5 text-[14.5px] text-neutral-800 leading-relaxed font-medium" data-testid="aff-idea-text">{data.idea}</p>
        <p className="mt-2 text-[11px] text-neutral-400">{isEs ? 'Una idea nueva cada día — Eva, tu coach de ventas' : 'A fresh idea every day — Eva, your sales coach'}</p>
      </div>
      <div className="rounded-2xl border border-neutral-200 bg-white p-5" data-testid="aff-recommendations">
        <p className="flex items-center gap-2 text-[11px] uppercase tracking-wider text-neutral-500 font-bold">
          <Compass className="w-4 h-4 text-[#F77F11]" /> {isEs ? 'Recomendado para ti ahora' : 'Recommended for you now'}
        </p>
        <div className="mt-2.5 space-y-2">
          {(data.recommendations || []).map((r, i) => (
            <p key={i} className="text-[13px] text-neutral-600 leading-relaxed">· {r}</p>
          ))}
        </div>
      </div>
    </div>
  );
};
